import BlockType121Component from '@headlines/components/block/121-130/BlockType121.vue';
import { AdminBlockType } from '@headlines/types/block/adminBlockType';
import AdminBlockTypeAttributes from '@headlines/config/block/shared/attributes/AdminBlockTypeAttributes';

const AdminBlockType121: AdminBlockType = {
  component: BlockType121Component,
  attributes: AdminBlockTypeAttributes({}),
  articlesCount: 0,
};

export default AdminBlockType121;
